export const rowLetters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']
